import { useContext } from "react";
import { EventRulePriceContext } from "../contexts/EventRulePriceContext";

function useInitialize() {
  const {setElement, setShowModal} = useContext(EventRulePriceContext);
  return () => {
    setElement({});
    setShowModal(true);
  }
}

export default useInitialize;